import Accordion from "./Accordion";
import Button from "./Button";
import Field from "./Field";
import Heading from "./Heading";
import Image from "./Image";
import Li from "./Li";
import Ol from "./Ol";
import Paragraph from "./Paragraph";
import Sub from "./Sub";
import Sup from "./Sup";
import Ul from "./Ul";

interface Props {
  contentValue: any;
}

const components = {
  accordion: Accordion,
  p: Paragraph,
  h1: Heading,
  h2: Heading,
  h3: Heading,
  h4: Heading,
  h5: Heading,
  img: Image,
  button: Button,
  li: Li,
  ul: Ul,
  ol: Ol,
  sup: Sup,
  sub: Sub,
  field: Field,
} as { [key: string]: React.ElementType };

export default function Content(props: Props) {
  const { contentValue } = props;

  return contentValue?.map((child: any, index: number) => {
    if (child.type) {
      const Component = components[child.type] || Paragraph;
      return <Component key={index} contentComponents={components} {...child} />;
    } else {
      const { bold, italic, underline } = child;
      let children = child.text;
      if (bold) {
        children = <strong key={index}>{child.text}</strong>;
      }
      if (italic) {
        children = <em key={index}>{children}</em>;
      }
      if (underline) {
        children = <u key={index}>{children}</u>;
      }

      return children;
    }
  });
}
